export enum ModalPaddingSize {
    None = 'none',
    Small = 'small',
    Medium = 'medium',
}
